import { render, staticRenderFns } from "./MiniChat.vue?vue&type=template&id=2b86de25"
import script from "./MiniChat.vue?vue&type=script&lang=js"
export * from "./MiniChat.vue?vue&type=script&lang=js"
import style0 from "./MiniChat.vue?vue&type=style&index=0&id=2b86de25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
